module.exports = __webpack_public_path__ + "img/file5.537ada3e.png";